import React from 'react';
import GroupLightComponent from './configs/LightGroupConfig';
import {GruposPaginas} from '../../configs/iluminação'

const IntermediarioPagina = () => {
  return (
    <div className="intermediario-container">
      <GroupLightComponent
        groupIds={GruposPaginas[1]}
        //startIndex={20}  // Começa onde o térreo termina
        //endIndex={40}    // Ajuste conforme o número total de luzes
        pageTitle="Luzes do Intermediário" 
      />
    </div>
  );
};

export default IntermediarioPagina;